import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t bg-muted/40">
      <div className="container mx-auto flex flex-col items-center gap-4 py-8 px-6 md:flex-row md:justify-between">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <img src="/assets/lgs-mark.png" alt="" className="h-6 w-6" />
          <span>&copy; {new Date().getFullYear()} Loose Goose Systems LLC. All rights reserved.</span>
        </div>
        <nav className="flex items-center gap-6 text-sm">
          <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
            Privacy Policy
          </Link>
          <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
            About
          </Link>
        </nav>
      </div>
    </footer>
  );
}
